/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchAccounts200ResponseResultsInner } from './SearchAccounts200ResponseResultsInner';
import {
    SearchAccounts200ResponseResultsInnerFromJSON,
    SearchAccounts200ResponseResultsInnerFromJSONTyped,
    SearchAccounts200ResponseResultsInnerToJSON,
    SearchAccounts200ResponseResultsInnerToJSONTyped,
} from './SearchAccounts200ResponseResultsInner';

/**
 * 
 * @export
 * @interface SearchAccounts200Response
 */
export interface SearchAccounts200Response {
    /**
     * 
     * @type {Array<SearchAccounts200ResponseResultsInner>}
     * @memberof SearchAccounts200Response
     */
    results?: Array<SearchAccounts200ResponseResultsInner>;
    /**
     * 
     * @type {number}
     * @memberof SearchAccounts200Response
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchAccounts200Response
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchAccounts200Response
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchAccounts200Response
     */
    query?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchAccounts200Response
     */
    duration?: number;
}

/**
 * Check if a given object implements the SearchAccounts200Response interface.
 */
export function instanceOfSearchAccounts200Response(value: object): value is SearchAccounts200Response {
    return true;
}

export function SearchAccounts200ResponseFromJSON(json: any): SearchAccounts200Response {
    return SearchAccounts200ResponseFromJSONTyped(json, false);
}

export function SearchAccounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAccounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(SearchAccounts200ResponseResultsInnerFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'query': json['query'] == null ? undefined : json['query'],
        'duration': json['duration'] == null ? undefined : json['duration'],
    };
}

  export function SearchAccounts200ResponseToJSON(json: any): SearchAccounts200Response {
      return SearchAccounts200ResponseToJSONTyped(json, false);
  }

  export function SearchAccounts200ResponseToJSONTyped(value?: SearchAccounts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(SearchAccounts200ResponseResultsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'query': value['query'],
        'duration': value['duration'],
    };
}

